"use client";
import React, { useEffect } from "react";
import { useProductDetailsContext } from "@/src/provider/ProductDetails/context";
import { viewContentEvent } from "@/src/components/LoadAnalysis/commonEvent";

// 需要在客户端进行初始化的使用这个组件
const ProductDetailInit: React.FC = () => {
    const [activeObj, productDetail] = useProductDetailsContext((state) => [
        state.activeObj,
        state.productDetail,
    ]);

    useEffect(() => {
        viewContentEvent(productDetail, activeObj);
    }, [productDetail, activeObj]);

    return <></>;
};

export default ProductDetailInit;
